import { useQuery } from '@tanstack/react-query';

import { getConfig } from '~/controllers/config';
import { EmptyJiraConfig } from '~/domain/IBackendConfig';
import { STALE_TIME_5MIN } from '~/queryCache';

export const useJiraProjectConfig = () => {
  const query = useQuery(
    ['jiraProjectConfig'], getConfig,
    {
      staleTime: STALE_TIME_5MIN,
    }
  );
  return {
    ...query,
    data: query.data?.jiraConfig || EmptyJiraConfig,
  }
};
